import { useContext, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
// extend dayjs to support UTC parsing
dayjs.extend(utc);

import { LocationAddress } from '@components';
import { GlobalContext } from '@contexts';
import {
  Edit2Icon,
  ExternalLinkIcon,
  MonitorIcon,
  MoreHorizontalIcon,
} from '@svgs';

import './PostRow.scss';

const PostRow = ({ post, postUrl }) => {
  const { t, i18n } = useTranslation();
  const globals = useContext(GlobalContext);

  // menu activation
  const dropdownMenu = useRef(null);
  const [showDropdownMenu, setShowDropdownMenu] = useState(false);
  const closeOpenMenus = (e) => {
    if (showDropdownMenu && !dropdownMenu.current?.contains(e.target)) {
      setShowDropdownMenu(false);
    }
  };
  document.addEventListener('mousedown', closeOpenMenus);

  return (
    <div className="sb-row-item">
      <div className="sb-row--post-title">
        <p>
          <Link
            to={
              postUrl ||
              `/dashboard/sites/${post.site_id}/blogs/posts/${post.id}`
            }
          >
            {post.title}
          </Link>
        </p>
      </div>
      <div className="sb-row--post-date">
        {dayjs.utc(post.date).local().format('MMMM D, YYYY')}
      </div>
      <div className="sb-row--post-tags">
        <p>
          {post.published === false && (
            <span
              className="sb-row-tag"
              title="Blog post is unpublished, will 404"
            >
              Unpublished
            </span>
          )}
        </p>
      </div>
      {/**
      <div className="sb-options">
        <button
          className="sb-page-options-menu-trigger sb-options-trigger"
          onClick={() => setShowDropdownMenu(!showDropdownMenu)}>
          <MoreHorizontalIcon/>
        </button>
        <div ref={dropdownMenu} className={"sb-options-menu " + (showDropdownMenu ? "sb-show": "sb-hide")}>
          <div className="sb-options-menu-content">
            <a
              href={post.slug} target="_blank"
              className="sb-options-item"
            >
              <MonitorIcon/>
              {t('View blog post')}
            </a>
          </div>
        </div>
      </div>
      **/}
    </div>
  );
};

export default PostRow;
